import { Box, FormControlLabel } from '@mui/material';
import type { FC } from 'react';

import { RadioInput } from './commonComponents';

type CookieToggleProps = {
	checked: boolean;
	dataTestid: string;
	onChange: () => void;
};

export const CookieToggle: FC<CookieToggleProps> = ({ checked, onChange, dataTestid }) => (
	<Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', mt: 1, mb: 1 }}>
		<FormControlLabel
			control={
				<RadioInput
					data-testid={`${dataTestid}-on`}
					checked={checked}
					onChange={onChange}
					sx={{
						paddingTop: 0,
						paddingBottom: 0,
						paddingLeft: 0,
					}}
				/>
			}
			label="On"
		/>
		<FormControlLabel
			control={
				<RadioInput
					data-testid={`${dataTestid}-off`}
					checked={!checked}
					onChange={onChange}
					sx={{
						paddingTop: 0,
						paddingBottom: 0,
						paddingLeft: 0,
					}}
				/>
			}
			label="Off"
		/>
	</Box>
);
